import { api } from "../api";

const limitKeys = [
  "daily_credits",
  "daily_requests",
  "per_user_daily_credits",
  "per_user_daily_requests",
];

export async function renderUserbot(el: HTMLElement): Promise<void> {
  el.innerHTML = `<h1>Userbot</h1><div id="userbot-root">Loading...</div>`;
  const root = el.querySelector<HTMLElement>("#userbot-root")!;
  let q = "";
  let type = "";
  let enabled = "";

  async function load(): Promise<void> {
    const summary = await api.userbotSummary();
    const { chats, total } = await api.userbotChats(0, 100, q, type, enabled);
    const s = summary.settings || {};
    const limits = s.limits || {};
    root.innerHTML = `
      <div class="cards">
        <div class="card"><div class="label">Runtime</div><div class="value tag ${s.enabled ? "ok" : "warn"}">${s.enabled ? "enabled" : "disabled"}</div></div>
        <div class="card"><div class="label">Enabled chats</div><div class="value">${summary.enabled_chats || 0}/${summary.total_chats || 0}</div></div>
        <div class="card"><div class="label">Today requests</div><div class="value">${summary.today_requests || 0}</div></div>
        <div class="card"><div class="label">Today spend</div><div class="value">${summary.today_credits || 0} cr</div></div>
      </div>

      <div class="card" style="margin-bottom:18px">
        <h2>Global settings</h2>
        <form id="settings" class="toolbar" style="align-items:end">
          <label><input name="enabled" type="checkbox" ${s.enabled ? "checked" : ""}/> Enabled</label>
          <label>Prefix <input name="trigger_prefix" value="${escapeAttr(s.trigger_prefix || ".ai")}" style="width:90px"/></label>
          <label><input name="auto_enable_private" type="checkbox" ${s.auto_enable_private ? "checked" : ""}/> Auto private</label>
          <label><input name="auto_enable_groups" type="checkbox" ${s.auto_enable_groups ? "checked" : ""}/> Auto groups</label>
          <label><input name="respond_to_private" type="checkbox" ${s.respond_to_private !== false ? "checked" : ""}/> Private</label>
          <label><input name="respond_to_groups" type="checkbox" ${s.respond_to_groups !== false ? "checked" : ""}/> Groups</label>
          <label>Chat cr/day <input name="daily_credits" type="number" value="${limits.daily_credits ?? 0}" style="width:105px"/></label>
          <label>Chat req/day <input name="daily_requests" type="number" value="${limits.daily_requests ?? 0}" style="width:95px"/></label>
          <label>User cr/day <input name="per_user_daily_credits" type="number" value="${limits.per_user_daily_credits ?? 0}" style="width:105px"/></label>
          <label>User req/day <input name="per_user_daily_requests" type="number" value="${limits.per_user_daily_requests ?? 0}" style="width:95px"/></label>
          <button>Save</button>
        </form>
        <p class="meta">0 in any limit means unlimited. Env USERBOT_ENABLED and Pyrogram credentials still gate the service process.</p>
      </div>

      <div class="toolbar">
        <input id="q" placeholder="Search title, username or id" value="${escapeAttr(q)}"/>
        <select id="type">
          <option value="" ${type === "" ? "selected" : ""}>all types</option>
          <option value="private" ${type === "private" ? "selected" : ""}>private</option>
          <option value="group" ${type === "group" ? "selected" : ""}>group</option>
          <option value="supergroup" ${type === "supergroup" ? "selected" : ""}>supergroup</option>
          <option value="channel" ${type === "channel" ? "selected" : ""}>channel</option>
        </select>
        <select id="enabled">
          <option value="" ${enabled === "" ? "selected" : ""}>all states</option>
          <option value="true" ${enabled === "true" ? "selected" : ""}>enabled</option>
          <option value="false" ${enabled === "false" ? "selected" : ""}>disabled</option>
        </select>
        <button class="ghost" id="reload">Reload</button>
      </div>
      <p class="meta">${total} chats</p>
      <div class="table-wrap"><table>
        <thead><tr><th>ID</th><th>Chat</th><th>State</th><th>Chat cr</th><th>Chat req</th><th>User cr</th><th>User req</th><th>Total</th><th>Last seen</th><th></th></tr></thead>
        <tbody>${chats.map(row).join("")}</tbody>
      </table></div>
    `;

    root.querySelector<HTMLFormElement>("#settings")!.addEventListener("submit", async e => {
      e.preventDefault();
      const form = e.currentTarget as HTMLFormElement;
      const fd = new FormData(form);
      await api.updateUserbotSettings({
        enabled: fd.get("enabled") === "on",
        trigger_prefix: String(fd.get("trigger_prefix") || ".ai"),
        auto_enable_private: fd.get("auto_enable_private") === "on",
        auto_enable_groups: fd.get("auto_enable_groups") === "on",
        respond_to_private: fd.get("respond_to_private") === "on",
        respond_to_groups: fd.get("respond_to_groups") === "on",
        limits: collectFormLimits(fd),
      });
      await load();
    });

    root.querySelector<HTMLInputElement>("#q")!.addEventListener("change", e => { q = e.currentTarget.value.trim(); load(); });
    root.querySelector<HTMLSelectElement>("#type")!.addEventListener("change", e => { type = e.currentTarget.value; load(); });
    root.querySelector<HTMLSelectElement>("#enabled")!.addEventListener("change", e => { enabled = e.currentTarget.value; load(); });
    root.querySelector<HTMLButtonElement>("#reload")!.addEventListener("click", load);

    root.querySelectorAll<HTMLButtonElement>("button[data-save]").forEach(btn => {
      btn.addEventListener("click", async () => {
        const id = Number(btn.dataset.save);
        const enabledBox = root.querySelector<HTMLInputElement>(`input[data-enabled="${id}"]`)!;
        await api.updateUserbotChat(id, {
          enabled: enabledBox.checked,
          limits: collectRowLimits(root, id),
        });
        btn.textContent = "Saved";
        setTimeout(() => (btn.textContent = "Save"), 1200);
      });
    });
    root.querySelectorAll<HTMLButtonElement>("button[data-reset]").forEach(btn => {
      btn.addEventListener("click", async () => {
        const id = Number(btn.dataset.reset);
        await api.resetUserbotUsage(id);
        await load();
      });
    });
  }

  await load();
}

function row(c: any): string {
  const l = c.limits || {};
  const title = c.title || c.username || "";
  const err = c.last_error ? `<div class="tag danger">${escape(c.last_error)}</div>` : "";
  return `<tr>
    <td><code>${c.id}</code></td>
    <td>${escape(title)}<div class="meta">${escape(c.type || "")}</div>${err}</td>
    <td><input type="checkbox" data-enabled="${c.id}" ${c.enabled ? "checked" : ""}/></td>
    ${limitKeys.map(k => `<td><input data-limit="${k}" data-id="${c.id}" type="number" value="${l[k] ?? 0}" style="width:88px"/></td>`).join("")}
    <td>${c.total_credits || 0} cr<div class="meta">$${Number(c.total_cost_usd || 0).toFixed(4)}</div></td>
    <td>${String(c.last_seen_at || "").slice(0, 19).replace("T", " ")}</td>
    <td><button data-save="${c.id}">Save</button> <button class="ghost" data-reset="${c.id}">Reset</button></td>
  </tr>`;
}

function collectFormLimits(fd: FormData): Record<string, number> {
  const out: Record<string, number> = {};
  for (const key of limitKeys) out[key] = Math.max(0, Number(fd.get(key) || 0));
  return out;
}

function collectRowLimits(root: HTMLElement, id: number): Record<string, number> {
  const out: Record<string, number> = {};
  for (const key of limitKeys) {
    const input = root.querySelector<HTMLInputElement>(`input[data-limit="${key}"][data-id="${id}"]`)!;
    out[key] = Math.max(0, Number(input.value || 0));
  }
  return out;
}

function escape(s: string): string {
  return s.replace(/[&<>"']/g, c => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]!));
}

function escapeAttr(s: string): string { return escape(s); }
